$(document).ready(function(){
  if (window.location.href.split('#')[1] == "recover") {
    $('#reset-password').click();
  }
  // Account forms
  $('#birthday--input').bind('keyup','keydown', function(event) {
    var inputLength = event.target.value.length;
    var code = event.keyCode || event.which;
    if((inputLength === 2 || inputLength === 5) && code != 8) {
      var thisVal = event.target.value;
      thisVal += '/';
      $(event.target).val(thisVal);
    }
  })

  $('input[type="email"]').bind('keyup','keydown', function(event) {
    var thisVal = event.target.value.toLowerCase().trim();
    $(event.target).val(thisVal);
  })

  $('#newsletter--label').on('click', function() {
    $('#newsletter--checkbox').prop( "checked", !$('#newsletter--checkbox').is(':checked'));
    $('label.error[for="newsletter"]').text('');
  })

  $(".oeil--mdp").click(function () {
    $(".oeil--mdp").css("display", "none");
    $(".oeil-ferme--mdp").css("display", "block");
    $("#password--input, #ResetPassword, #PasswordConfirmation").attr("type","");
  });
  $(".oeil-ferme--mdp").click(function () {
    $(".oeil-ferme--mdp").css("display", "none");
    $(".oeil--mdp").css("display", "block");
    $("#password--input, #ResetPassword, #PasswordConfirmation").attr("type","password");
  });
  minlength: jQuery.validator.format("Please enter at least {0} characters."),
  // Validate form
    $.validator.messages.required = 'Ce champ est requis.';
    $.validator.messages.email = 'Veuillez entrer une adresse email valide.';
    $.validator.messages.number = 'Vous devez entrer un nombre.';
    $.validator.messages.phoneNumber = 'Vous devez entrer un numéro de téléphone';
    $.validator.messages.minlength = 'Merci d\'entrer au moins {0} caractères.';
    $.validator.messages.equalTo = 'Les deux mots de passe doivent être identiques.';
    $.validator.addMethod("birthday", function(value, element) {
      var regexResult = value.match(/^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/);
      if (!value) {
        regexResult = true;
      }
      return regexResult ? true : false;
    }, "Veuillez entrer une date valide au format JJ/MM/AAAA.");

    $.validator.addMethod("firstName", function(value, element) {
      var regexResult = value.match(/^[a-zA-Z àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ-]+$/);
      return regexResult ? true : false;
    }, "Merci d'entrer un prénom valide.");

    $.validator.addMethod("lastName", function(value, element) {
      var regexResult = value.match(/^[a-zA-Z àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ-]+$/);
      if (!value) {
        regexResult = true;
      }
      return regexResult ? true : false;
    }, "Merci d'entrer un nom valide.");

    function validateForm(id) {
      var validator = $(id).validate({
        rules: {
         "tags[birthday]": {
            "required": false,
            "birthday": true,
            "maxlength": 10
         },
         "customer[first_name]": {
            "required": true,
            "firstName": true
         },
         "customer[last_name]": {
            "required": false,
            "lastName": true
         },
         "customer[email]": {
            "required": true,
            "email": true
         },
         "email": {
            "required": true,
            "email": true
         },
         "customer[password]": {
            "required": true,
            "minlength": 5
         },
         "customer[password_confirmation]": {
            "required": true,
            "minlength": 5,
            "equalTo": "#ResetPassword"
         }
        }
      })

      var result = validator.form();
      if (result == false) {
        $('.button__account').children('.button--text').css('display', 'block');
        $('.button__account').children('.button--loading').css('display', 'none');
      }
      return result;
    }
  // Validation form --> Register
  $('#create_customer').submit(function(e) {
    var formValidated = validateForm("#create_customer");
    if (formValidated) {
      var civilite = $('#motif__selection--contact').val();
      var birthday = $('#birthday--input').val();
      var newsletter = $('#newsletter--checkbox').is(":checked");

      var tags = "civilite:" + civilite + ',newsletter:' + newsletter
      if (birthday) {
        tags = tags + ',birthday:' + birthday
      }
      $('#customer--tags').val(tags);
      return true;
    } else {
      e.preventDefault();
    }
  })

  function submitForm(selector) {
    $(selector).submit(function(e) {
      var formValidated = validateForm(selector);
      if (formValidated) {
        return true;
      } else {
        e.preventDefault();
      }
    })
  }
  // Validation form --> Login
  submitForm('#customer_login')

  // Validation form --> Reset password
  submitForm('.reset--password')

  // Validation form --> Reinitialize mdp
  submitForm('.reinitialize--password')
})
